<template>
  <div class="m-homepage-offers layout" v-if="config && config.nodes">
    <h2 class="visually-hidden hidden-label">
      <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">去探索</font></font>
    </h2>
    <div class="ms-row m-offers animatedParent animateOnce">
      <template v-for="(item, index) in config.nodes">
        <div :class="cls[index]" :key="index">
          <a href="javascript:void(0);" class="link--no-decoration"></a>
          <div class="c-text-image c-text-image–-third">
            <a href="javascript:void(0);" @click="actionHandler(item.action)" class="link--no-decoration">
              <div class="c-text-image__visual">
                <div class="c-text-image__visual-container">
                  <img class="c-text-image__item lazyloaded" :alt="item.title" :src="item.src">
                </div>
                <!-- 标签 -->
                <template v-if="item.badges">
                  <template v-for="(badge, badgeIndex) in badges">
                    <div class="c-text-image__tag c-text-image__tag--gold heading-h3" :style="{backgroundColor: `#${badge}`}" :key="badgeIndex">{{badge.text}}</div>
                  </template>
                </template>
              </div>
            </a>
            <div class="c-text-image__content">
              <a href="javascript:void(0);" class="link--no-decoration"></a>
              <div class="c-text-image__text">
                <a href="javascript:void(0);" @click="actionHandler(item.action)" class="link--no-decoration">
                  <h3 class="c-text-image__title heading-h4 text--letter-spacing-normal" style="color:#000000">{{item.title}}</h3>
                  <div class="c-text-image__description" style="color:#575757">{{item.desc}}</div>
                </a>
                <div class="c-text-image__link" style="color:#000000">
                  <a href="javascript:void(0);" class="link--no-decoration"></a>
                  <a href="javascript:void(0);" @click="actionHandler(item.action)" class="link-with-arrow" v-if="item.button">{{item.button}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import actionMixins from '@/utils/action.mixins';

export default {
  name: "ImageFlexHair",
  mixins: [actionMixins],
  props: {
    config: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      cls: [
        "col-xs-12 col-md-6 col-sm-10 m-offers__item",
        "col-xs-12 col-md-offset-1 col-md-5 end-xs m-offers__item animated delay-500 fadeIn go",
        "col-xs-12 col-md-6 center-md m-offers__item animated delay-500 fadeIn go",
        "col-xs-12 col-md-6 center-xs start-md m-offers__item animated delay-1500 fadeIn go"
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .hidden-label { position: absolute; font-size: 0; }
  .conceal, .invisible, .visually-hidden { visibility: hidden; }
  .link--no-decoration {
    text-decoration: none;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
  .c-text-image__title { margin-top: .6875rem; font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; text-transform: none; }
  .c-text-image { display: block; width: 100%; text-decoration: none; }
  .c-text-image–-third {
    display: inline-block;
    .c-text-image__title {
      font-family: HelveticaNeueLTW05-45Light,arial,sans-serif;
      line-height: normal;
      padding-top: 1rem;
      margin-bottom: 0;
      margin-top: 0;
    }
    .c-text-image__visual {
      position: relative;
      display: inline-block;
    }
    .c-text-image__content {
      display: flex;
      .c-text-image__text {
        flex-grow: 1;
        width: 0;
        text-align: left;
      }
    }
    .c-text-image__description {
      font-size: .8125rem;
      font-family: HelveticaNeueLTW05-45Light,arial,sans-serif;
      line-height: normal;
      padding-top: .4375rem;
    }
    .c-text-image__link {
      padding: .9375rem 1.25rem 0 0;
      line-height: normal;
    }
    .c-text-image__tag {
      position: absolute;
      top: 1.25rem;
      left: -.625rem;
    }
  }
  .text--letter-spacing-normal { letter-spacing: normal; }
  
  .c-text-image__tag {
    font-family: HelveticaNeueLTW05-45Light,arial,sans-serif;
    color: #fff;
    padding: .3125rem .625rem;
    display: inline-block;
  }
  .c-text-image__tag--gold {
    background-color: #b19665;
  }
  .m-homepage-offers {
    padding: 0 0 2.5rem;
  }
  .m-offers {
    .c-text-image–-third {
      padding: 2.5rem 0 1.125rem;
    }
  }
  .m-offers__item {
    &:first-child {
      padding: 0 1.0625rem;
      .c-text-image {
        max-width: 100%;
      }
    }
    &:nth-child(2) {
      .c-text-image {
        max-width: 78%;
      }
      .c-text-image__description {
        margin-right: 1.875rem;
      }
      .c-text-image–-third {
        .c-text-image__link {
          margin-right: 1.25rem;
        }
      }
    }
    &:nth-child(3) {
      padding: 0 1.0625rem;
      .c-text-image {
        max-width: 71.5%;
      }
    }
    &:nth-child(4) {
      .c-text-image {
        max-width: 71.5%;
      }
    }
    .c-text-image__content {
      position: relative;
    }
  }
  


  @media screen and (max-width: 47.9375em) {
    .m-offers { margin: 0; }
    .m-offers__item {
      &:nth-child(2) {
        padding: 0;
      }
    }
  }

  @media screen and (min-width: 48em) {
    .c-text-image__title { margin-top: 1.0625rem; }
    .c-text-image–-third {
      .c-text-image__title {
        margin-top: 0;
      }
      .c-text-image__description {
        line-height: 1.3125rem;
        padding-top: .6875rem;
      }
      .c-text-image__link {
        padding-top: .75rem;
      }
      .c-text-image__tag {
        top: 1.875rem;
      }
    }
    .m-offers__item {
      &:first-child {
        padding: 0 0 0 4.25rem;
      }
      &:nth-child(2) {
        .c-text-image {
          max-width: 63%;
        }
        .c-text-image__description {
          margin-right: 1.875rem;
        }
      }
      &:nth-child(3) {
        padding: 0 4.25rem;
        .c-text-image {
          max-width: 54%;
        }
      }
      &:nth-child(4) {
        .c-text-image {
          max-width: 54%;
        }
      }
    }
  }
  @media screen and (min-width: 64em) {
    .c-text-image–-third {
      .c-text-image__visual-container {
        display: block;
        overflow: hidden;
      }
      .c-text-image__item {
        transition: all .3s;
        max-width: 100%;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
    .m-offers {
      .c-text-image–-third {
        padding: 5rem 0 0;
      }
    }
    .m-offers__item {
      &:first-child {
        padding: 0 .9375rem;
      }
      &:nth-child(2) {
        .c-text-image {
          max-width: 100%;
        }
        .c-text-image__visual {
          margin-top: 8.375rem;
        }
      }
      &:nth-child(3) {
        padding: 0 .9375rem;
        .c-text-image {
          max-width: 65%;
        }
        .c-text-image__visual {
          margin-top: -15rem;
        }
      }
      &:nth-child(4) {
        .c-text-image {
          max-width: 65%;
        }
      }
    }
  }
  @media screen and (min-width: 75em) {
    
    .m-homepage-offers {
      padding: 0 0 3.125rem;
    }
    .m-offers__item {
      &:nth-child(2) {
        .c-text-image__description {
          margin-right: 0;
        }
      }
    }
  }
</style>